import {TipoPropostaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';

export class FormatarUtil {
  static cpf(cpf: string): string {
    if (!cpf) return '';
    const numeros = cpf.replace(/\D/g, '');
    if (numeros.length <= 3) return numeros;
    if (numeros.length <= 6)
      return `${numeros.slice(0, 3)}.${numeros.slice(3)}`;
    if (numeros.length <= 9)
      return `${numeros.slice(0, 3)}.${numeros.slice(3, 6)}.${numeros.slice(
        6,
      )}`;
    return `${numeros.slice(0, 3)}.${numeros.slice(3, 6)}.${numeros.slice(
      6,
      9,
    )}-${numeros.slice(9, 11)}`;
  }

  static cep(cep: string): string {
    if (!cep) return '';
    const numeros = cep.replace(/\D/g, '');
    if (numeros.length <= 5) return numeros;
    return `${numeros.slice(0, 5)}-${numeros.slice(5, 8)}`;
  }

  static telefone(telefone: string): string {
    if (!telefone) return '';
    const numeros = telefone.replace(/\D/g, '');
    if (numeros.length === 10) {
      return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 6)}-${numeros.slice(
        6,
      )}`;
    } else if (numeros.length === 11) {
      return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 7)}-${numeros.slice(
        7,
      )}`;
    } else if (numeros.length === 8) {
      return `${numeros.slice(0, 4)}-${numeros.slice(4)}`;
    } else if (numeros.length === 9) {
      return `${numeros.slice(0, 5)}-${numeros.slice(5)}`;
    } else {
      return numeros;
    }
  }

  static data(data: string): string {
    if (!data) return '';
    if (data.includes('T') && data.length >= 10) {
      const dataPart = data.substring(0, 10);
      const [ano, mes, dia] = dataPart.split('-');
      return `${dia}/${mes}/${ano}`;
    }
    return data;
  }

  static sexo(sexo: number): string {
    switch (sexo) {
      case 1:
        return 'M';
      case 2:
        return 'F';
      default:
        return String(sexo) || '';
    }
  }

  static cns(cns: string): string {
    if (!cns) return '';
    const numeros = cns.replace(/\D/g, '');
    if (numeros.length <= 3) return numeros;
    if (numeros.length <= 7)
      return `${numeros.slice(0, 3)} ${numeros.slice(3)}`;
    if (numeros.length <= 11)
      return `${numeros.slice(0, 3)} ${numeros.slice(3, 7)} ${numeros.slice(
        7,
      )}`;
    return `${numeros.slice(0, 3)} ${numeros.slice(3, 7)} ${numeros.slice(
      7,
      11,
    )} ${numeros.slice(11, 15)}`;
  }

  static resposta(resposta: any): string {
    if (!resposta) return 'N';
    if (resposta.codeQuestion === 27 && resposta.height) {
      return `${(resposta.height / 100).toFixed(2)}`;
    }
    if (resposta.codeQuestion === 28 && resposta.weight) {
      return `${resposta.weight}`;
    }
    return resposta.response ? 'S' : 'N';
  }

  static cid(cidObj: any): string {
    if (!cidObj) {
      return 'Não informado';
    }

    if (cidObj.cidCode && cidObj.description) {
      return `${cidObj.cidCode} - ${cidObj.description}`;
    }

    if (cidObj.cidCode) {
      return cidObj.cidCode;
    }

    if (cidObj.description) {
      return cidObj.description;
    }

    return 'Não informado';
  }

  static assinatura(dados: any): {data: string; hora: string} {
    if (!dados) return {data: '', hora: ''};
    const dataDaAssinatura = new Date(dados);
    const data = this.data(dados);
    const hora = dataDaAssinatura.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
    return {data, hora};
  }
  // como usar const dataHora = FormatarUtil.getDataHoraAssinatura(beneficiario, 'SUMULA'); // Retorna: {data: '15/10/2023', hora: '14:30:00'}
  static getDataHoraAssinatura(
    beneficiario: any,
    tipoModal: string,
  ): {data: string; hora: string} {
    return (
      beneficiario?.assinaturasPorTipo?.[tipoModal] || {
        data: 'Data não disponível',
        hora: 'Hora não disponível',
      }
    );
  }
  //const dataAssinatura = FormatarUtil.getDataAssinatura(beneficiario); // Retorna: '15/10/2023'

  static getDataAssinatura(beneficiario: any): string {
    const tipo =
      beneficiario.proposalType === TipoPropostaEnum.SUMULA
        ? 'SUMULA'
        : 'PORTABILIDADE';
    return this.getDataHoraAssinatura(beneficiario, tipo).data;
  }
  //const horaAssinatura = FormatarUtil.getHoraAssinatura(beneficiario); // Retorna: '14:30:00'
  static getHoraAssinatura(beneficiario: any): string {
    const tipo =
      beneficiario.proposalType === TipoPropostaEnum.SUMULA
        ? 'SUMULA'
        : 'PORTABILIDADE';
    return this.getDataHoraAssinatura(beneficiario, tipo).hora;
  }
}
